export const educationData = [
	{
		institute: "neogCamp",
		course: "Full Stack Development Bootcamp (MERN stack)",
		location: "Remote",
		startDate: "Jan 2022",
		endDate: "June 2022",
		result: "",
		resultType: "",
	},
	{
		institute: "Pimpri Chinchwad College of Engineering and Research (PCCOER)",
		course: "BE, Computer Engineering",
		location: "Pune, India",
		startDate: "Aug 2017",
		endDate: "May 2021",
		result: "9.64",
		resultType: "CGPA",
	},
	{
		institute: "Lancers Army School",
		course: "12th",
		location: "Surat, India",
		startDate: "Apr 2016",
		endDate: "March 2017",
		result: "92.8%",
		resultType: "Percentage",
	},
];
